import axios from 'axios'
import Cookie from 'js-cookie'
import { getCtCookie } from 'src/core/helpers'
import { ct_sid_name, ct_vid_name } from '../../core/models'

export async function postVisitorAPI({ ct_vid }: { ct_vid : string }) {
  await axios.post('/api/v1/visitors/', { ct_vid })
}

export async function postTrackingEventAPI(url: string, event: string, eventValue = null) {
  const ct_sid_cookie = getCtCookie(ct_sid_name)
  const ct_vid_cookie = getCtCookie(ct_vid_name)
  const referral = Cookie.get('referral_code') || null
  const values = {
    event,
    url: `/accounts${url}`,
    ct_sid: ct_sid_cookie,
    ct_vid: ct_vid_cookie,
    eventValue: eventValue,
    referral,
    integration: null
  }
  await axios.post('/api/v1/visitors/add_track_event/', values)
}
